import { Component, OnInit, HostListener } from '@angular/core';
import { DatabusService } from '../../shared/services/databus.service';
import { ValidationService } from '../../shared/services/validation.service';
import { DecodeTicketService } from '../../shared/services/decode-ticket.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-scanticket',
  templateUrl: './scanticket.component.html',
  styleUrls: ['./scanticket.component.scss']
})
export class ScanticketComponent implements OnInit {
  showSpinner: boolean = false;
  fullString: string = '';
  previous: string = null;
  scanComplete: boolean = false;

  showError: boolean = false;

  constructor (
    private dataSvc: DatabusService,
    private decoder: DecodeTicketService,
    private validate: ValidationService,
    private router: Router ) {
    }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if ( event.which !== 13 && 
      event.which !== 40 &&
      event.key !== 'Shift' ) {
      this.fullString += event.key;
      this.previous = event.key;
    }

    if ( event.which === 13 ) {
      this.showSpinner = true;
      this.scanComplete = true;
      this.processScan(this.fullString);
    }
  }

  processScan (scan) {
    let ticket = this.cleanScan(scan);
    let validTicket = this.decoder.decode(ticket);

    if( validTicket['status'] === 'OK' ) {
      if (validTicket['code'].length === 12) {
        this.dataSvc.currentClubCard = validTicket['code'];
      } else {
        this.dataSvc.currentTicket = validTicket;
      }
      
      if(!this.dataSvc.currentClubCard || !this.dataSvc.currentEmail) {
        this.router.navigate(['/enterid']);
      } else if ((this.dataSvc.currentClubCard || this.dataSvc.currentEmail) && !this.dataSvc.currentTicket) {
        this.router.navigate(['/scananother']);
      } else {
        this.router.navigate(['/success']);
      }
    } else {
      this.showSpinner = false;
      this.router.navigate(['/invalid']);
    }
  }

  cleanScan(scan) {
    scan = scan.substr(scan.lastIndexOf('/') + 1);
    let ticket = scan.split('-').join('');
    return ticket;
  }

  ngOnInit() {
    this.dataSvc.reset();
  }
}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/scanticket/scanticket.component.ts